import {
	Component,
	OnInit,
	ChangeDetectorRef,
	Input,
	Output,
	EventEmitter,
} from '@angular/core';
// import { ProfileComponent } from '../../../views/pages/profile/profile.component';
import { Router } from '@angular/router';
import { LoaderService } from '../../../../../../app/shared/sharedServices/loader.service';
import { HecResponse } from '../../../../../../app/shared/shared-interfaces/hecResponse';
import { SharedService } from '../../../../../../app/shared/sharedServices/shared.service';
import { HEC_CONSTANTS } from '../../../../../../app/utilities/constants';
import { SubjectService } from '../../../puca/components/puca-form/puca-upload-Documents/services/subject.service';

@Component({
	selector: 'kt-emp-details',
	templateUrl: './emp-details.component.html',
	styleUrls: ['./emp-details.component.scss'],
})
export class EmpDetailsComponent implements OnInit {
	public formView: any;
	public newEducationAddFormDisplay: boolean = false;
	public step = 0;
	public data;
	public employmentDetailGridData: any;
	public employmentDetailsData: any;
	public viewform: boolean = false;
	public isAlertVisible: boolean = false;
	public alertType: string;
	public alertIcon: string;
	public alertMsgValue: string;
	public dateError: string = '';
	public selectedDateError: boolean = false;
	public formType: string = 'cp';
	@Input('dropdownList') dropdownList: any;
	@Input('isApplicationForm') isApplicationForm: any;
	@Input('formViewType') formViewType: any;
	@Input('enableSaveButton') enableSaveButton: boolean = false;
	public viewTypes: any = HEC_CONSTANTS.APP_FORM_VIEWS;
	public empFormDropdowns: any = [];

	@Output() nextComponent: EventEmitter<any> = new EventEmitter();
	@Output() backComponent: EventEmitter<any> = new EventEmitter();

	constructor(
		private cdr: ChangeDetectorRef,
		private sharedServices: SharedService,
		private router: Router,
		private subjectService: SubjectService,
		private loaderService:LoaderService
	) { }

	async ngOnInit() {
		window.scroll(0, 0);
		this.getEmploymentListData();
		this.getEmploymentDetails();
	}

	public getEmploymentListData() {
		this.subjectService.appDataLoading.next({ appDataLoading: true });
		this.sharedServices.getEmploymentDetails().subscribe(
			(res: HecResponse) => {
				this.subjectService.appDataLoading.next({ appDataLoading: false });
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.empFormDropdowns = res.data.formDto;
				} else {
					this.subjectService.appDataLoading.next({ appDataLoading: false });
					this.cdr.detectChanges();
				}
			},
			(err) => {
				this.subjectService.appDataLoading.next({ appDataLoading: false });
				this.cdr.detectChanges();
			}
		);
	}

	public getEmploymentDetails() {
		this.loaderService.setValue(true);
		this.subjectService.appDataLoading.next({ appDataLoading: true });
		this.sharedServices.getEmploymentInfoDetails().subscribe(
			(res: HecResponse) => {
				this.subjectService.appDataLoading.next({ appDataLoading: false });
				this.loaderService.setValue(false);
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.employmentDetailGridData =
						res.data.profileDto.employmentHistoryDtos;
					if (
						res.data.profileDto.employmentHistoryDtos &&
						res.data.profileDto.employmentHistoryDtos.length > 0
					) {
						this.data = res.data.profileDto.employmentHistoryDtos.sort(
							(ob1, ob2) => {
								if (!ob1['endDate']) {
									return -1;
								}
								if (!ob2['endDate']) {
									return 1;
								}
								if (new Date(ob2.endDate) < new Date(ob1.endDate))
									return -1
								else if (new Date(ob2.endDate) > new Date(ob1.endDate))
									return 1;
								else return 0;
							}
						);
					} else {
						this.data = [];
					}
					this.subjectService.appDataLoading.next({ appDataLoading: false });
					this.cdr.detectChanges();
					// this.cdr.markForCheck();
				} else {
					this.subjectService.appDataLoading.next({ appDataLoading: false });
					this.cdr.detectChanges();
				}
			},
			(err) => {
				this.loaderService.setValue(false);
				this.subjectService.appDataLoading.next({ appDataLoading: false });
				this.cdr.detectChanges();
			}
		);
	}

	public async openEducationDetails(data, index, type) {
		this.formView = type;
		this.employmentDetailsData = data;
		this.viewform = true;
		this.cdr.detectChanges();
	}

	public deleteEducation(educationData) {
		this.subjectService.appDataLoading.next({ appDataLoading: true });
		this.isAlertVisible = false;
		educationData.activeIndicator = false;
		let payload = {
			data: educationData,
		};
		this.sharedServices.saveOrUpdateEmployment(educationData).subscribe(
			(res: HecResponse) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.getEmploymentDetails();
				} else {
					this.subjectService.appDataLoading.next({ appDataLoading: false });
					this.alertMsgValue = 'Error in deleting Employment';
					this.alertType = 'error';
					this.isAlertVisible = true;
					this.cdr.detectChanges();
				}
			},
			(err) => {
				this.subjectService.appDataLoading.next({ appDataLoading: false });
				this.alertMsgValue = 'Error in deleting Employment';
				this.alertType = 'error';
				this.isAlertVisible = true;
				this.cdr.detectChanges();
			}
		);
	}

	public getDate(date): any {
		let convertedDate = new Date(date).toISOString();
		return convertedDate;
	}

	public getEduDate(date): any {
		for (let i = 0; i < this.employmentDetailGridData.length; i++) {
			if (
				new Date(date).getFullYear() +
				'-' +
				(new Date(date).getMonth() + 1) +
				'-' +
				new Date(date).getDate() >=
				new Date(this.employmentDetailGridData[i].startDate).getFullYear() +
				'-' +
				(new Date(this.employmentDetailGridData[i].startDate).getMonth() +
					1) +
				'-' +
				new Date(this.employmentDetailGridData[i].startDate).getDate() &&
				new Date(date).getFullYear() +
				'-' +
				(new Date(date).getMonth() + 1) +
				'-' +
				new Date(date).getDate() <=
				new Date(this.employmentDetailGridData[i].endDate).getFullYear() +
				'-' +
				(new Date(this.employmentDetailGridData[i].endDate).getMonth() +
					1) +
				'-' +
				new Date(this.employmentDetailGridData[i].endDate).getDate()
			) {
				this.dateError = this.employmentDetailGridData[i].qualificationLevel;
				this.selectedDateError = true;
				this.cdr.detectChanges();
				this.cdr.markForCheck();
			} else {
				this.selectedDateError = false;
				this.dateError = undefined;
				this.cdr.detectChanges();
			}
		}
	}

	public goToDegreeAttest(data) {
		localStorage.setItem('edu', JSON.stringify(data));
		this.router.navigate(['/das-app']);
	}

	public addNewEmployment() {
		this.formView = 'new';
		this.employmentDetailsData = [];
		this.viewform = true;
		this.cdr.detectChanges();
		this.cdr.markForCheck();
	}

	public cancelEmployment(event) {
		if (event == 'cancel') {
			this.viewform = false;
			this.cdr.detectChanges();
		}
	}

	public getUpdatedEmployment(employmentStatus) {
		this.viewform = false;
		this.isAlertVisible = false;
		if (employmentStatus.id) {
			this.alertMsgValue = 'Employment Update Successfully';
			this.alertType = 'success';
			this.isAlertVisible = true;
		} else {
			this.alertMsgValue = 'Employment Added Successfully';
			this.alertType = 'success';
			this.isAlertVisible = true;
		}
		this.getEmploymentDetails();
		setTimeout(() => {
			this.isAlertVisible = false;
			this.cdr.detectChanges();
		}, 3000);
	}

	public goNext(): void {
		this.nextComponent.emit(true);
	}

	public goBack(): void {
		this.backComponent.emit(true);
	}

	public saveForm() {
		this.router.navigate(['/applicant-dashboard']);
	}
}
